<template>
  <v-row>
    <v-col
      :class="'py-0 my-n2 ' + (i == 0 ? 'pl-0' : '')"
      cols="auto"
      v-for="(item, i) in sorted_statuses"
      :key="i"
    >
      <v-card-text class="px-0">
        <goal-avatar :status="item"></goal-avatar>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import goalStatusTypes from "@/helpers/mixins/goalStatusTypes";
import { mapGetters } from "vuex";
import GoalAvatar from "@/components/goals/GoalAvatar";
export default {
  name: "GoalAvatars",
  components: { GoalAvatar },
  mixins: [goalStatusTypes],
  props: { statuses: { type: Array } },
  computed: {
    sorted_statuses() {
      return this.sortGoalStatuses(this.statuses);
    },
    ...mapGetters({
      goal_statuses: "lookup/goal_statuses"
    })
  }
};
</script>
